import { DataEnum } from "models/groupBy";

/**
 * Whether BinSettings offers Max Bins for a field: only an unbinnable, non-date
 * field has a Max Bins, so only it can produce an Others bin.
 */
export const supportsMaxBins = (
  canBin: Maybe<boolean>,
  dataType: Maybe<string>
): boolean => !canBin && dataType !== DataEnum.Date;
